import { getRequest, putRequest, severityCode } from "./httpClient";

const END_POINT = "dashboard/widget";

const getAvailableWidgets = async (partyType) => {
  return await getRequest(`${END_POINT}`, { partyType });
};

const getUserWidgets = async (partyId, userId) => {
  return await getRequest(`${END_POINT}/${partyId}/${userId}`);
};

const updateUserWidgets = async (partyId, userId, widgets) => {
  return await putRequest(`${END_POINT}/${partyId}/${userId}`, widgets);
};

export { getAvailableWidgets, getUserWidgets, updateUserWidgets, severityCode };